var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Swipeable from 'react-swipeable';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import * as BetStatus from '../../../constants/BetStatus';
import * as BetCreateErrorStatus from '../../../constants/BetCreateErrorStatus';
import { getRateDisplayValue } from '../../../rendering-commons';
var messages = defineMessages({
    delete: {
        id: 'coupon.delete',
        defaultMessage: 'Удалить',
    },
    rate_changed: {
        id: 'bet_history.errors.factor_changed',
        defaultMessage: 'Коэффициент изменился!'
    },
    event_closed: {
        id: 'coupon.event_closed',
        defaultMessage: 'Event closed'
    },
    alternativeStake: {
        id: 'bet_history.errors.max_stake',
        defaultMessage: 'Max stake amount {amount} {currency}'
    },
    stake_accepted: {
        id: 'coupon.stake_accepted',
        defaultMessage: 'Ставка на {amount}{currency} принята!',
    },
    big_bet: {
        id: 'coupon.big_bet',
        defaultMessage: 'Крупная ставка',
    },
    no_big_stake_permission: {
        id: 'bet_history.errors.no_big_stake_permission',
        defaultMessage: 'Крупные ставки запрещены',
    },
});
var RenderBetItem = /** @class */ (function (_super) {
    __extends(RenderBetItem, _super);
    function RenderBetItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            active: false
        };
        _this.onClick = function () {
            _this.props.prompt && _this.props.betSlipsPromptClose();
            _this.setState({
                active: !_this.state.active
            });
        };
        _this.onSwipeLeft = function (e, absX) {
            if (absX !== 0) {
                _this.setState({
                    active: true
                });
            }
        };
        _this.onSwipeRight = function () {
            _this.props.prompt && _this.props.betSlipsPromptClose();
            _this.setState({
                active: false
            });
        };
        _this.delete = function () {
            _this.props.deleteBetSlip(_this.props.rate.get('id'));
        };
        return _this;
    }
    RenderBetItem.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.prompt !== this.props.prompt && nextProps.prompt) {
            this.setState({
                active: nextProps.prompt
            });
        }
    };
    RenderBetItem.prototype.render = function () {
        var _a = this.props, rate = _a.rate, disabled = _a.disabled, couponStatus = _a.couponStatus, couponAmount = _a.couponAmount, accountResourceName = _a.accountResourceName, intl = _a.intl, currency = _a.currency;
        var active = this.state.active;
        var isLive = rate.get('isLive') ? _jsx("span", __assign({ className: 'live' }, { children: "live" })) : '';
        var actualValue = rate.get('actualValue');
        var value = getRateDisplayValue(rate.get('value'));
        var alternativeStake;
        var rateSpan = _jsx("div", __assign({ className: 'rate' }, { children: value }));
        if (actualValue) {
            var cls = actualValue > value ? 'new-rate-symbol-up' : 'new-rate-symbol-down';
            rateSpan = (_jsxs("div", __assign({ className: 'rate rate--changed' }, { children: [_jsx("span", { children: rate.get('value') }), _jsxs("span", __assign({ className: cls }, { children: [actualValue, _jsx("span", {})] }))] })));
        }
        var changedUp = actualValue !== undefined && actualValue > value;
        var changedDown = actualValue !== undefined && actualValue < value;
        var msg = '';
        if (couponStatus) {
            alternativeStake = couponStatus.get('alternativeStake');
            if (couponStatus.get('status') === BetStatus.CONFIRMED) {
                msg = (_jsx("div", __assign({ className: 'item__message item__message-up' }, { children: _jsx(FormattedMessage, __assign({}, messages.stake_accepted, { values: { amount: couponAmount, currency: accountResourceName } })) })));
            }
            if (couponStatus.get('status') === BetStatus.STAKE_REQUEST) {
                msg = (_jsx("div", __assign({ className: 'item__message' }, { children: _jsx(FormattedMessage, __assign({}, messages.big_bet)) })));
            }
            if (couponStatus.get('betCreateError') === BetCreateErrorStatus.NO_BIG_STAKE_PERMISSION) {
                msg = (_jsx("div", __assign({ className: 'item__message item__message-up' }, { children: _jsx(FormattedMessage, __assign({}, messages.no_big_stake_permission)) })));
            }
        }
        var deleteTxt = intl.formatMessage(messages.delete);
        var matchName = this.props.match.get('name');
        if (this.props.match.get('notice')) {
            matchName += '(' + this.props.match.get('notice') + ')';
        }
        var headerTitle = matchName === this.props.outcome.get('name')
            ? _jsxs("div", __assign({ className: 'title' }, { children: [rate.get('shortName'), " ", isLive] }))
            : _jsxs("div", __assign({ className: 'title' }, { children: [this.props.outcome.get('name'), " \u00A0 ", rate.get('shortName'), " ", isLive] }));
        return (_jsxs("div", __assign({ className: "with-triangle ".concat(active ? 'active' : '') }, { children: [_jsxs("div", __assign({ className: "header ".concat(disabled ? 'disabled' : ''), onClick: this.onClick }, { children: [_jsx(Swipeable, __assign({ onSwipedLeft: this.onSwipeLeft, onSwipingRight: this.onSwipeRight }, { children: _jsxs("div", __assign({ className: "header-inner ".concat(active ? 'active' : '') }, { children: [_jsxs("div", __assign({ className: 'header-left' }, { children: [headerTitle, _jsxs("div", __assign({ className: 'sub' }, { children: [matchName, " "] }))] })), rateSpan] })) })), _jsx("div", __assign({ className: 'delete', onClick: this.delete }, { children: deleteTxt }))] }), 'betItem-1'), msg, !disabled && changedUp &&
                    _jsx("div", __assign({ className: 'item__message item__message-up' }, { children: _jsx(FormattedMessage, __assign({}, messages.rate_changed)) })), !disabled && changedDown &&
                    _jsx("div", __assign({ className: 'item__message' }, { children: _jsx(FormattedMessage, __assign({}, messages.rate_changed)) })), disabled &&
                    _jsx("div", __assign({ className: 'item__message' }, { children: _jsx(FormattedMessage, __assign({}, messages.event_closed)) })), alternativeStake &&
                    _jsx("div", __assign({ className: 'item__message' }, { children: _jsx(FormattedMessage, __assign({}, messages.alternativeStake, { values: { amount: alternativeStake, currency: currency } })) }))] })));
    };
    return RenderBetItem;
}(React.Component));
;
RenderBetItem.propTypes = {
    match: PropTypes.object.isRequired,
    outcome: PropTypes.object.isRequired,
    rate: PropTypes.object.isRequired,
    deleteBetSlip: PropTypes.func.isRequired,
    prompt: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    betSlipsPromptClose: PropTypes.func.isRequired
};
export default injectIntl(RenderBetItem);



// WEBPACK FOOTER //
// ./src/components/coupon/betTypesComponents/RenderBetItem.jsx